// Listens to/updates page facets for radio button changes to 'sort'
// Adapted from https://gist.github.com/djrmom/1321763f4e600456de371f3801824733

jQuery(document).on('facetwp-loaded', function () {
		const facetwpSortButtons = jQuery('.facetwp-sort-radio input:radio[name="sort"]')
		
		// select the radio button for the currently selected sort method, if it exists
		if ('undefined' !== typeof FWP.extras.sort) {
				facetwpSortButtons.filter('[value="' + FWP.extras.sort + '"]').prop("checked", true);
		}

		// Listen for change and update sorting
		jQuery(document).on('change', '.facetwp-sort-radio input', function () {
				// Set the sort and reload the facets
				FWP.extras.sort = jQuery(this).val();
				FWP.soft_refresh = true;
				FWP.autoload();
		});
});
